import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { shortMonthAndFullYear } from "@similarweb/pro-logic-components";

import type { SelectorHandlers } from "app/components/filters-bar/useSelectorTrigger";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";

const getDateRange = (durationObject) => [durationObject.raw.from, durationObject.raw.to];
const getCompareDateRange = (durationObject) => [durationObject.raw.compareFrom, durationObject.raw.compareTo];

const useSubtitleFilters = (comparedDurationParam?: string, handlers: SelectorHandlers = {}) => {
    const { params } = useCurrentStateAndParams();

    const { country, duration, webSource } = params;
    const { onDateClick, onCountryClick, onDateHover, onCountryHover, onWebSourceHover } = handlers;

    const durationObject = DurationService.getDurationData(duration, comparedDurationParam);
    const [fromDate, toDate] = getDateRange(durationObject);
    const [compareFromDate, compareToDate] = getCompareDateRange(durationObject);

    const subTitleFilters = useMemo(
        () => [
            {
                filter: "date",
                value: {
                    from: fromDate.valueOf(),
                    to: toDate.valueOf(),
                    useRangeDisplay: fromDate.format(shortMonthAndFullYear) !== toDate.format(shortMonthAndFullYear),
                    compareFrom: compareFromDate?.valueOf(),
                    compareTo: compareToDate?.valueOf(),
                },
                onClick: onDateClick,
                onMouseEnter: onDateHover,
            },
            {
                filter: "country",
                countryCode: country,
                value: CountryService.getCountryById(country)?.text,
                onClick: onCountryClick,
                onMouseEnter: onCountryHover,
            },
            {
                filter: "webSource" as const,
                value: webSource,
                onMouseEnter: onWebSourceHover,
            },
        ],
        [
            fromDate,
            toDate,
            compareFromDate,
            compareToDate,
            country,
            webSource,
            onDateClick,
            onCountryClick,
            onDateHover,
            onCountryHover,
            onWebSourceHover,
        ],
    );
    return { subTitleFilters };
};

export default useSubtitleFilters;
